import type { APIFieldAttributes, APIFieldType } from '@ardoq/api-types';

export const toFieldTypeRecord = (
  fieldsByName: Map<string, APIFieldAttributes>
): Record<string, APIFieldType> =>
  Object.fromEntries(
    Array.from(fieldsByName, ([name, field]): [string, APIFieldType] => [
      name,
      field.type,
    ])
  );
